"use strict";

import angular from "angular";


function bxMenuProvider() {
    var menu = false;
    var deffered = null;
  
    this.loadMenu = function () {
      var injector = angular.injector(['ng']),
  
        $q = injector.get('$q');
  
      deffered = $q.defer();
        let bx = window.BX;
        bx.ajax.runComponentAction('cript:desktop', 'menu', {
          mode: 'class',
          data: {}
        })
  
        .then(function (response) {
          if (response.status == "success") {
            menu = response.data;
            deffered.resolve(menu);
          }
        }, function () {
          deffered.resolve([]);
        });
  
  
      return deffered.promise;
  
    };
  
    this.$get = function () {
      var bxMenu = {};
  
      bxMenu.getMenu = function () {
        return deffered.promise;
      };
  
      return bxMenu;
    };
  }

export { bxMenuProvider };


// WEBPACK FOOTER //
// ./src/app.providers.bxmenu.js